<div class="container-fluid">
  <div class="row">
    <div class="col-sm-8 mx-auto">
      <div class="card tab2-card ">
        <div class="card-body tab2-card">
          <div class="form-group row">
            <img class="responsive" src="../../../../assets/images/homepage-logo.png" alt="">
          </div>

          <!--<div class="form-group row justify-content-md-center">
            <div class="center-item" style=" align-content: center; text-align: center">
              <div placement="bottom" class="d-inline-block dropdown alert alert-warning"
                style=" align-content: center; text-align: center; ">
                Până la încărcarea şi validarea tuturor datelor de către operatorii de rețea și furnizori, clienții
                finali au acces în POSF la următoarele funcții:
                Înregistrare/Autentificare utilizator, Completare date de identificare, Asociere locuri de consum și
                vizualizarea datelor aferente contractelor de furnizare încărcate în POSF, Vizualizare oferte tip în
                comparatorul de oferte.
              </div>
            </div>
          </div>-->

          <ng-container *ngIf="page === home">
            <div class="center-item mb-4" style=" align-content: center; text-align: center">
              <div class="form-group d-lg-flex flex-lg-row flex-column justify-content-md-center">
                <div class="col mt-5">
                  <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                    <button class="btn btn-primary responsiveButton" type="button" id="dropdownMenuButton"
                            aria-expanded="false" [routerLink]="['/comparator']"
                            [queryParams]="{comparatorType: 'electric'}">
                      {{ offerComparisonElectricity }}
                    </button>
                  </div>
                </div>
                <div class="col mt-5">
                  <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                    <button class="btn btn-primary responsiveButton" type="button" id="dropdownMenuButton"
                            aria-expanded="false" [routerLink]="['/comparator']"
                            [queryParams]="{comparatorType: 'gas'}">
                      {{ offerComparisonGas }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="form-group row justify-content-md-center">
            <div class="d-flex justify-content-center" style="gap: 50px;">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/QRk1TwmVxGY?si=DvL6YihrQD-PDFeT"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/qseDw6wNzW8?si=fyGxeehwtJL5ZPOM"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          <ng-container *ngIf="page === home">
            <div style="width: 80%; align-content: center; margin-left: 10%" class="mt-5">
              <label class="bold">{{ homepageTitle }}</label>
            </div>
            <div style="width: 80%; align-content: center; margin-left: 10%" class="mt-3">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>{{ homepageText1 }} </label>
            </div>
            <div style="width: 80%; align-content: center; margin-left: 10%" class="mt-3">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>{{ homepageText2 }} </label>
            </div>
            <div style="width: 80%; align-content: center; margin-left: 10%" class="mt-3">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>{{ homepageText3 }} </label>
            </div>

            <div class="center-item" style=" align-content: center; text-align: center">
              <div class="form-group row justify-content-md-center">
                <div class="col mt-5">
                  <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                    <button class="btn btn-primary responsiveButton" type="button" style="align-content: center">
                      <a (click)="login()">
                        Autentificare Utilizator
                      </a>
                    </button>
                  </div>
                </div>
                <div class="col mt-5">
                  <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                    <button class="btn btn-primary responsiveButton" type="button">
                      <a (click)="inregistrare()">
                        Înregistrare Utilizator
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--<div class="form-group row justify-content-md-center mt-5">
              <div class="center-item" style=" align-content: center; text-align: center">
                <div placement="bottom" class="d-inline-block dropdown"
                     style=" align-content: center; text-align: center; ">
                  <div class="form-group row justify-content-md-center">
                    <div class="center-item">
                      <div placement="bottom" class="d-inline-block dropdown">
                        <button class="btn btn-primary responsiveButton" type="button" id="dropdownMenuButton"
                                aria-expanded="false" [routerLink]="['/comparator']"
                                [queryParams]="{comparatorType: 'electric'}">
                          {{ offerComparisonElectricity }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row justify-content-md-center">
                    <div class="center-item">
                      <div placement="bottom" class="d-inline-block dropdown">
                        <button class="btn btn-primary responsiveButton" type="button" id="dropdownMenuButton"
                                aria-expanded="false" [routerLink]="['/comparator']"
                                [queryParams]="{comparatorType: 'gas'}">
                          {{ offerComparisonGas }}
                        </button>
                      </div>
                    </div>
                  </div>
                  &lt;!&ndash; <form action="https://anre.ro/comparator-energie-electrica/">
                    <button class="btn btn-primary responsiveButton" id="dropdownMenuButton" aria-expanded="false">
                      {{offerComparisonElectricity}}
                    </button>
                  </form>
                  <form action="https://anre.ro/comparator-gaze-naturale/">
                    <button class="mt-1 btn btn-primary responsiveButton" id="dropdownMenuButton" aria-expanded="false">
                      {{offerComparisonGas}}
                    </button>
                  </form> &ndash;&gt;
                </div>
              </div>
            </div>-->
            <div class="bold mt-3" style="width: 100%; align-content: center; text-align: center;">
              <label style="font-size: 16px; text-align: center;">
                POSF a fost realizată în cadrul proiectului “Dezvoltarea capacităţii instituţionale a Autorităţii
                Naţionale de Reglementare în domeniul energiei pentru simplificarea procesului de schimbare a
                furnizorului de energie electrică si de gaze naturale” – Cod SMIS 129990/705
              </label>
            </div>
            <div class="bold mt-3" style="width: 100%; align-content: center; text-align: center;">
              <label style="font-size: 16px; text-align: center;">
                Lista operatorilor de rețea operationalizati o puteți găsi <a
                href="https://posf.ro/broker/export/operational" target="_blank">aici</a>
              </label>
            </div>
            <div class="bold mt-3" style="width: 100%; align-content: center; text-align: center;">
              <label style="font-size: 16px; text-align: center;">
                Lista furnizorilor operationalizati o puteți găsi <a
                href="https://posf.ro/broker/export/furnizor/operational" target="_blank">aici</a>
              </label>
            </div>
            <div class="card-header">
              <img class="responsive" src="../../../../assets/images/homepage-footer.png" alt="">
            </div>

            <div class="form-group row align-items-center">

              <div class="col-xl-8 mx-auto" style="align-content: center; text-align: center; ">
                <label style="font-size: 16px; text-align: center;">
                  Proiect cofinanțat din Fondul Social European prin Programul Operațional Capacitate Administrative
                  2014-2020
                </label>
              </div>

              <div class="col-xl-8 mx-auto bold" style="align-content: center; text-align: center; ">
                <label style="font-size: 12px; text-align: center;">
                  Conținutul acestei pagini web nu reprezintă in mod obligatoriu poziția oficială a Uniunii Europene.
                  Întreaga responsabilitate asupra corectitudinii și coerenței informațiilor prezentate revine
                  inițiatorilor paginii web.
                </label>
              </div>

              <div class="col-xl-8 mx-auto" style="align-content: center; text-align: center; ">
                <label style="font-size: 12px; text-align: center;">
                  Pentru informații detaliate despre celelalte programe cofinantate de Uniunea Europeană, vă invităm
                  să
                  vizitați <a href="https://www.fonduri-ue.ro">www.fonduri-ue.ro</a>
                </label>
              </div>
            </div>

          </ng-container>

          <ng-container *ngIf="page === contact">
            <div class="form-group row justify-content-md-center">
              Operatorul POSF este Autoritatea Națională de Reglementare în Domeniul Energiei
            </div>

            <div class="form-group row justify-content-md-center">
              <label style="font-size: 18px; text-align: center;">
                Date de contact ANRE
              </label>
            </div>

            <div class="form-group row justify-content-md-center">
              <a href="https://www.anre.ro">www.anre.ro</a>
              <span style="width: 100%; text-align: center">
                Adresa: Str. Constantin Nacu nr. 3, Bucureşti, Sector 2, Cod poştal 020995, ROMANIA
              </span>
            </div>

            <div class="form-group row justify-content-md-center">
              Informații - 021-9782 (Linie telefonică dedicată informării consumatorilor de energie electrică și gaze
              naturale)
              <span style="width: 100%; text-align: center">
                Luni - vineri: 9:00 - 17:00
              </span>
            </div>

            <div class="form-group row justify-content-md-center">
              Registratură: 021-327.81.74; 021-327.81.00 Fax: 021-312.43.65
              <span style="width: 100%; text-align: center">
                Luni - Joi: 8:00 - 16:30, Vineri: 8:00 - 14:00
              </span>
            </div>

            <div class="form-group row justify-content-md-center pt-5">
              <div class="center-item" style=" align-content: center; text-align: center">
                <div placement="bottom" class="d-inline-block dropdown"
                     style=" align-content: center; text-align: center; ">
                  <button class="btn btn-primary responsiveButton" id="dropdownMenuButton" aria-expanded="false">
                    Sesizează o problemă legată de funcționarea POSF
                  </button>
                </div>
              </div>
            </div>

            <div class=" form-group row justify-content-md-center p-3">
              <div class="center-item" style=" align-content: center; text-align: center">
                <div placement="bottom" class="d-inline-block dropdown"
                     style=" align-content: center; text-align: center; ">
                  <a class="btn btn-primary responsiveButton" href="#" (click)="onPetitieClick($event)"
                     aria-expanded="false">
                    Adresează ANRE o petiție
                  </a>
                </div>
              </div>
            </div>

            <div class="form-group row justify-content-md-center pb-5">
              <div class="center-item" style=" align-content: center; text-align: center">
                <div placement="bottom" class="d-inline-block dropdown"
                     style=" align-content: center; text-align: center; ">
                  <button class="btn btn-primary responsiveButton" id="dropdownMenuButton" aria-expanded="false">
                    Intrebări frecvente
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="page === despre">
            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                POSF este platforma informatică unică la nivel național dedicată clienților finali de energie
                electrică și
                gaze naturale, care optimizează procesele operaționale generate de solicitările de schimbare a
                furnizorului, prin gestionarea fluxurilor de informații și documente în mod automatizat, unitar și
                prin
                implementarea unui cadru de lucru accesibil participanților la piață implicați.
              </div>
            </div>

            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                Prin intermediul POSF clientul final de energie electrică/gaze naturale poate să:
              </div>
            </div>

            <div style="align-content: center; margin-left: 10%">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>Vizualizeze și să gestioneze locurile proprii de consum</label>
            </div>

            <div style="align-content: center; margin-left: 10%">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>Vizualizeze și să gestioneze contractele de furnizare </label>
            </div>

            <div style="align-content: center; margin-left: 10%">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>Aleagă din comparator ofertele de contracte de furnizare pe care le consideră potrivite</label>
            </div>

            <div style="align-content: center; margin-left: 10%">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>Transmită furnizorului toate informațiile și documentele necesare contractării</label>
            </div>

            <div style="align-content: center; margin-left: 10%">
              <i class="fa fa-check-circle" style="font-size: 18px; color:#004995; margin-right: 5px;"></i>
              <label>Schimbe furnizorul în cel mult 24 de ore de la încheierea noului contractului sau de la
                data dorită</label>
            </div>

            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                Prin intermediul POSF furnizorii de energie electrică/gaze naturale validează cererile de încheiere a
                contractelor de furnizare, înregistrează și gestionează contractele de furnizare și datele despre
                clienții
                finali din portofoliu și contractele încheiate cu operatorii de rețele/sisteme.
              </div>
            </div>
            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                Prin intermediul POSF operatorii de rețele/sistem de electrică/gaze naturale înregistrează și
                gestionează locurile de consum și contractele pentru prestarea serviciilor de rețea.
              </div>
            </div>
            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                POSF a fost realizată în cadrul proiectului “Dezvoltarea capacității instituționale a Autorității
                Naționale
                de Reglementare în Domeniul Energiei pentru simplificarea procesului de schimbare a furnizorul de
                energie electrică și de gaze naturale” - Cod SMIS 129990/705.
              </div>
            </div>
            <div class="form-group row justify-content-md-center pt-3">
              <div class="col-xl-11 mx-auto">
                Organizarea și funcționarea POSF se face în baza regulamentului specific aprobat prin Ordinul
                președintelui ANRE nr. 3/2022 cu modificările ulterioare.
              </div>
            </div>
          </ng-container>

          <div class="form-group row justify-content-md-center pt-3">
            <div class="center-item" style="width: 50%; align-content: center;text-align: center">
              <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                <i style="align-content: center">
                  <u><a href="../../../../assets/pdf/Termenii%20și%20Condițiile%20de%20utilizare%20a%20POSF.pdf">
                    Termeni și condiții de utilizare a POSF
                  </a></u>
                </i>
              </div>
            </div>

            <div class="center-item" style="width: 50%; align-content: center">
              <div class="center-item" style=" align-content: center; text-align: center">
                <div placement="bottom" class="d-inline-block dropdown" style="text-align: center">
                  <i style="align-content: center">
                    <u><a
                      href="../../../../assets/pdf/Termenii%20de%20prelucrare%20a%20Datelor%20cu%20Caracter%20Personal.pdf">
                      Protecția datelor personale
                    </a></u>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
